export const API_BASE = 'https://script.google.com/macros/s/AKfycbxupoukpAgUV0j21EpDMQJ5wUbgKInnnpPonsbocAO1COKNSze0LKuoHUxD5bjt4HC4mg/exec';

export type RsvpType = 'Yes' | 'No' | 'Maybe';
export type RsvpModel = {
    name: string;
    number_of_guests: number;
    attending: RsvpType;
    phone_number: number;
    event_id: number;
}

export type Event = {
    event_id: number;
    event_name: string;
    event_date: string;
    event_snapshot: string;
    location: string;
    details: string;
    max: number;
    is_hidden: boolean;
};


export const handleSubmit = async (data: RsvpModel) : Promise<void> => {
    const rsvpData = {
        name: data.name,
        phone_number: data.phone_number,
        number_of_guests: data.number_of_guests,
        attending: data.attending,
        event_id: data.event_id
        };

    try {
        const response = await fetch(`${API_BASE}?action=save_rsvp`, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(rsvpData)
        });

        if (!response.ok && response.type !== 'opaque') {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch(error) {
        console.error('Error:', error);
        throw error;
    }
};

export const getExistingRSVP = async (phoneNumber: string): Promise<RsvpModel[]> => {
    try {
        const response = await fetch(`${API_BASE}?action=rsvps`);
        const result = await response.json();
        const allRsvps: RsvpModel[] = Object.values(result).flat() as RsvpModel[];
        return allRsvps;
    } catch (error) {
        console.error('Error:', error);
        throw new Error('Failed to fetch RSVP data');
    }
}